"use strict";

import angular from "angular";

import { NPSGateway } from "../../../gateway/NPSGateway/NPSGateway";

export class NPSFormDialogController {
    constructor($stateParams, $mdDialog, locals) {
        this.$stateParams = $stateParams;
        this.$mdDialog = $mdDialog;
        this.locals = locals;

        this.companiesRating = locals.companiesRating;
        this.scores = new Array(11);
        this.scoreSelected = this.$stateParams.score;
        this.currentStep = 0;

        this.NPSGateway = new NPSGateway($stateParams.accountingId);

        this.contacts = [
            {
                name: "",
                contact: ""
            }
        ];
    }

    $onInit() {}

    scoreSelection(score) {
        this.scoreSelected = score;
    }

    async saveScore() {
        this.loading = true;
        if (this.scoreSelected > 8) this.currentStep = 1;
        else this.$mdDialog.cancel();
        this.locals.width = "596px";

        for (let rating of this.companiesRating) {
            await this.NPSGateway.setScoreRating({
                _id: rating._id,
                score: this.scoreSelected
            });

            if (this.comments) {
                await this.NPSGateway.setCommentedRating({
                    _id: rating._id,
                    comment: this.comments
                });
            }
        }

        this.loading = false;
    }

    async sendRecommendation() {
        this.loading = true;
        if (!this.contacts.length) return;
        for (let rating of this.companiesRating) {
            await this.NPSGateway.setRecommendationsRating({
                _id: rating._id,
                recommendations: this.contacts
            });
        }
        this.loading = false;
    }

    cancelRecommendation() {
        this.$mdDialog.cancel();
    }

    addContactDialog() {
        if (this.contacts.length < 5) {
            const itemToClone = {
                name: "",
                contact: ""
            };
            this.contacts.push(itemToClone);
        }
    }

    removeContactDialog($index) {
        this.contacts.splice($index, 1);
    }
}

angular.module("nucont.shared").controller("NPSFormDialogController", [
        "$stateParams",
        "$mdDialog",
        "locals",
        NPSFormDialogController
    ]);
